export default "__VITE_ASSET__d9d2bc28__"